import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid,
  TextField
} from '@mui/material';

import LocalHospitalIcon from '@mui/icons-material/LocalHospital';

export default function ProviderInfoSection({
  providerInfo,
  setProviderInfo
}) {
  const handleChange = (field) => (e) => {
    setProviderInfo((prev) => ({ ...prev, [field]: e.target.value }));
  };

  return (
    <Card sx={{ mb: 6 }}>
      <CardHeader
        title="Primary Care Provider (PCP) Information"
        avatar={<LocalHospitalIcon />}
        sx={{ backgroundColor: '#f5f5f5' }}
      />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Provider Name"
              fullWidth
              value={providerInfo.name}
              onChange={handleChange('name')}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="NPI"
              fullWidth
              value={providerInfo.npi}
              onChange={handleChange('npi')}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Medical Institution"
              fullWidth
              value={providerInfo.institution}
              onChange={handleChange('institution')}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Contact Phone"
              fullWidth
              value={providerInfo.phone}
              onChange={handleChange('phone')}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
